import { Injectable } from "@angular/core";
import { AuthProvider } from "../auth/auth";
import { Company } from "../../models/company";
import { AppConfig } from "../../config/app.config";
import { DataProvider } from "../data/data";

const ROUTE = '/api/companies/';

@Injectable()
export class CompanyProvider extends DataProvider<Company> {
    constructor(){
        super(ROUTE);
    }

    public async getStoreCompany(): Promise<Company>{
        return this.auth.get(ROUTE + this.config.companyId).then(x => x as Company);
    }
}


// WEBPACK FOOTER //
// ./src/providers/company/company.ts